<template lang="pug">
    transition(leave-active-class="animated fadeOut fast")
        div.is-intro
            img.animated.fadeInUp.slow(src="../assets/images/0_Intro/Logo_Intro-01.svg", alt="casa-relvas-logo")

</template>

<script>
export default {
    name: 'the-intro'
}
</script>

<style scoped lang="stylus">
.is-intro
    position fixed
    width: 100vw
    height  100vh
    left 0
    top 0
    z-index 100

    display flex
    justify-content center
    align-items center
    overflow hidden

    background-color white

    img
        width 12.5rem
</style>
